module.exports = __webpack_public_path__ + "media/country_flags/dj-1cdd48bf.png";